<template>
    <div class="page bgF5F5F5">

        <div style="height: 46px;">
            <header class="pageHeader detailPageHeader white_bg lightGreyBottomBorder" style="line-height: 44px;">
                <div class="borderLayout paddingH16">
                    <div class="middleRegion">
                        <div class="westRegion" style="width: 60px">
                            <span class="icon leftAngleBracketIcon floatL" style="margin-top: 11px;" @click="$router.back();"></span>
                        </div>
                        <div class="centerRegion alignCenter font18r primaryTextColor bold"
                             style="height: 44px; overflow: hidden">
                            {{title}}
                        </div>
                        <div class="eastRegion font14r alignRight" style="width: 60px">
                            <span class="orange font14r bold" @click="receive()">确定领取</span>
                        </div>
                    </div>
                </div>
            </header>
        </div>

        <div class="paddingH20 white_bg">

            <div class="content paddingB16">

                <div class="paddingV12 red font14r">{{dataItem ? dataItem.introduce : ''}}</div>

                <div class="item" v-for="(item , index) in (dataItem ? dataItem.realationList : [])" :key="index">
                    <div class="item_left">
                        <div class="item_img">
                            <img class="cover" :src="item.coverImg" alt="">
                        </div>
                        <div class="item_content">
                            <div class="item_title font14r bold">{{item.title}}</div>
                            <div class="marginT4 font12r grey">
                                领取截止时间：{{formatDateTime(dataItem ? dataItem.receiveTime : '')}}
                            </div>
                        </div>
                    </div>

                    <label>
                        <input type="checkbox" class="checkbox orangeCircleTickCheckbox size16" :value="item.bindBizInfo.id"
                           v-model="selectedIds"
                           :disabled="selectedIds.length >= dataItem.receiveLimit && !isSelectedGiftId(item.bindBizInfo.id)"
                           @change="onChangeGift"/>
                    </label>

                </div>
                <div class="alignCenter colorCCC bold" v-show="status == 'ready' && dataItem && dataItem.realationList.length < 1">
                    <img src="icon/userIcon/nocoure_icon.png" width="261" height="230" alt="无内容" />
                </div>
            </div>

            <div class="marginT20 paddingB20">
                <bannerModule ref="bannerModule" version="4" categoryKey="NEW_PEOPLE_GIFT_PAGE" />
            </div>

        </div>

    </div>
</template>

<script>
import shixunPagePart from '@/components/shixunApp/shixunPagePart';

// data
import externalApp from '@data/externalApp';
import orderBizTypeEnum from '@data/orderBizTypeEnum';

// modules
import bannerModule from '@/components/ad/bannerModule4';

// config
import appConfig from '@/appConfig';

// util
import appHelper from '@util/appHelper';
import arrayHelper from '@util/arrayHelper';
import {toDetailByBizType} from '@/components/shixunApp/toDetail';
import welfareApi from "@api/welfare";
import routeHelper from "@util/routeHelper";

const config = {
    apiConfig : {
        get : {
            url : 'portal/welfare/list',
            dataPath : 'data',
            dataColumnMapping : {
                // userName : 'name'
            }
        }
    },
    demoTitleList : [
        '奥尔夫音乐课程春秋课新精选课程',
        '如何使运营的微信公众号活跃起来？',
        '做好这几点，让园区摆脱对名师的依赖'
    ]
};

export default {
    name: "newPeopleLearnRequired",
    extends : shixunPagePart,
    components : { bannerModule },
    data () {
        return {
            title : '新人福利',
            apiConfig : config.apiConfig,

            enableDataItem : true,

            toDetailByBizType:toDetailByBizType,

            selectedIds : [],
            id : ''
        }
    },
    methods : {
        onLoadDataItem() {
            // this.title = this.dataItem.title;
            // if (this.dataItem.receiveLimit)
            // {
            //     appHelper.showHint('最多只能选' + this.dataItem.receiveLimit + '个');
            // }
        },
        isSelectedGiftId(id) {
            return arrayHelper.existElement(id, this.selectedIds);
        },
        onChangeGift() {
            if (this.dataItem.receiveLimit && this.selectedIds.length > this.dataItem.receiveLimit)
            {
                appHelper.showHint('最多选择' + this.dataItem.receiveLimit + '个');
                return;
            }
        },
        receive() {
            if (this.dataItem.receiveLimit && this.selectedIds.length > this.dataItem.receiveLimit)
            {
                appHelper.showHint('最多选择' + this.dataItem.receiveLimit + '个');
                return;
            }

            welfareApi.receive({
                id : this.id,
                bizId : JSON.stringify(this.selectedIds)
            }, (result) => {
                appHelper.showHint('领取成功');
                appHelper.goToPage('newPeopleGiftReceiveSuccess', {
                    id : this.id
                });
            });

        }
    },
    mounted() {
        let id = routeHelper.getParam(this,'id');
        this.id = id;
        this.loadDataItem(id);

    }
}
</script>

<style lang="scss" scoped>
.bannerLinkLayer {
    position: absolute;
    z-index: 1;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
}
.orange {
    color: #F4950E;
}
.red {
    color: #EE5555;
}
.grey {
    color: #B3B1B1;
}
.learnButton {
    width: 282px;
    height: 34px;
    line-height: 34px;
    background: #F4950E;
    border-radius: 4px;
    border: none;
    color: white;
}

.item{
    height: 58px;
    display: flex;
    margin-bottom: 18px;

    &:last-child {
        margin-bottom: 0;
    }
}
.item_left{
    display: flex;
    flex: 1;
    height: 100%;
    .item_img{
        width: 82px;
        height: 58px;
        border-radius: 4px;
        img{
            width: 82px;
            height: 58px;
            border-radius: 4px;
        }
    }
    .item_content{
        flex: 1;
        margin-left: 15px;
        position: relative;
        overflow: hidden;
        margin-right: 5px;

    }
}
.item_right{
    margin-top: 16px;
    padding: 2px 8px;
    color: #fff;
    height: 17px;
    font-size: 12px;

    font-weight: 400;

    // background: #FF4D51;

    background: #FFA724;
    border-radius: 12px;
}
</style>
